/**
 * Centralized programs registry for the application.
 * These program keys identify add-on products/programs that can be purchased
 * separately from the base subscription plan.
 *
 * Usage:
 * - Import: import { PROGRAMS } from '@/access/programs'
 * - Check if user has purchased a specific program/add-on
 * - Used with UsageLimitsModal and program-specific feature gating
 */
export const PROGRAMS = Object.freeze({
  PRODUCTS_SMS: 'productsSms', // SMS messaging add-on program
});
